import * as Yup from 'yup';

export const AddNewCitmfbBeneficiarySchema = Yup.object().shape({
  BeneficiariesAccountNo: Yup.string().required('Enter valid account number'),
  BeneficiariesAccountName: Yup.string().required(
    'Account number is not valid'
  ),
});
